import type { RequestComparison } from '../lib/requests-shared';

export interface RequestComposerState {
  description: string;
  title: string;
  stage: 'describe' | 'matches' | 'title';
  comparison: RequestComparison | null;
  submissionId: string;
  confirmDistinct: boolean;
}

export type RequestComposerAction =
  | { type: 'description'; value: string; submissionId: string }
  | { type: 'title'; value: string; submissionId: string }
  | { type: 'compared'; comparison: RequestComparison }
  | { type: 'distinct' }
  | { type: 'edit' }
  | { type: 'reset'; submissionId: string };

export function initialComposer(submissionId = ''): RequestComposerState {
  return { description: '', title: '', stage: 'describe', comparison: null, submissionId, confirmDistinct: false };
}

export function composerReducer(state: RequestComposerState, action: RequestComposerAction): RequestComposerState {
  switch (action.type) {
    case 'description':
      return { ...state, description: action.value, comparison: null, stage: 'describe', confirmDistinct: false,
        submissionId: state.description.trim() === action.value.trim() ? state.submissionId : action.submissionId };
    case 'title':
      return { ...state, title: action.value,
        submissionId: state.submissionId && state.title.trim() === action.value.trim() ? state.submissionId : action.submissionId };
    case 'compared':
      return { ...state, comparison: action.comparison, stage: action.comparison.matches.length ? 'matches' : 'title', confirmDistinct: false };
    case 'distinct':
      return { ...state, stage: 'title', confirmDistinct: true };
    case 'edit':
      return { ...state, stage: 'describe' };
    case 'reset':
      return initialComposer(action.submissionId);
  }
}

export function validDescription(description: string): boolean {
  return description.trim().length >= 20 && description.trim().length <= 4000;
}

export function validTitle(title: string): boolean {
  return title.trim().length >= 3 && title.trim().length <= 120;
}
